import axios from "./http.js";
const API_ENDPOINTS_BY_CATEGORY = {
  GET: {
    teams: "/v2/Favourites/teams",
    matches: "/v1/Favourites/matches",
    leagues: "/v2/Favourites/leagues",
    players: "/v1/Favourites/players"
  },
  POST: {
    teams: "/v2/Favourites/teams",
    matches: "/v2/Favourites/matches",
    leagues: "/v2/Favourites/leagues",
    players: "/v2/Favourites/players"
  },
  DELETE: {
    teams: "/v2/Favourites/teams",
    matches: "/v2/Favourites/matches",
    leagues: "/v2/Favourites/leagues",
    players: "/v2/Favourites/players"
  }
};
class FavoritesApi {
  static getFavorites() {
    const abortController = new AbortController();
    return {
      async call(category) {
        var _a;
        return axios.get(
          (_a = API_ENDPOINTS_BY_CATEGORY.GET[category]) != null ? _a : category,
          {
            signal: abortController.signal
          }
        );
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static setFavorite() {
    const abortController = new AbortController();
    return {
      async call({ category, itemId }) {
        var _a;
        return axios.post(
          ((_a = API_ENDPOINTS_BY_CATEGORY.POST[category]) != null ? _a : category) + `/${itemId}`,
          {},
          {
            signal: abortController.signal
          }
        );
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static deleteFavorite() {
    const abortController = new AbortController();
    return {
      async call({ category, itemId }) {
        var _a;
        return axios.delete(
          ((_a = API_ENDPOINTS_BY_CATEGORY.DELETE[category]) != null ? _a : category) + `/${itemId}`,
          {
            signal: abortController.signal
          }
        );
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
}
var stdin_default = FavoritesApi;
export {
  stdin_default as default
};
